import { API } from '@/apiError/apiShow';
import create from '@ant-design/icons/lib/components/IconFont';
// import { API } from '../config';

const adminMenuApiEndpoints = {
  retrieveList: async () => {
    return await API.get('/admin/menu/list/');
  },
};

/**
 * Company endpoints api
 */

const companyApiEndpoints = {
  retrieveList: async (signal) => {
    return await API.get('companies/', {
      signal,
    });
  },
  retrieve: async (id, signal) => {
    return await API.get(`/company/${id}/`, {
      signal,
    });
  },
  create: async (data) => {
    if (data?.financialYear) {
      delete data?.financialYear;
    }
    return await API.post('companies/', data);
  },
  update: async (id, data) => {
    if (data?.financialYear) {
      delete data?.financialYear;
    }
    return await API.patch(`/company/${id}/`, data);
  },
  delete: async (id) => {
    return await API.delete(`/company/${id}/`);
  },
  companyMappedMenuList: async () => {
    return await API.get('/company/menu/mapping/list/');
  },
};
const companyAccessEndpoints = {
  retrieveList: async (signal) => {
    return await API.get('company/access/list/', {
      signal,
    });
  },
};
const branchAccessEndpoints = {
  retrieveList: async (signal) => {
    return await API.get('branch/access/list/', {
      signal,
    });
  },
};

/**
 *  branch api
 */
const branchApiEndpoints = {
  retrieveList: async (signal) => {
    return await API.get('/branches/', {
      signal,
    });
  },
  retrieve: async (id, signal) => {
    return await API.get(`/branch/${id}/`, {
      signal,
    });
  },
  create: async (data) => {
    if (data?.financialYear) {
      delete data?.financialYear;
    }
    return await API.post('/branches/', data);
  },
  update: async (id, data) => {
    return await API.patch(`/branch/${id}/`, data);
  },
  delete: async (id) => {
    return await API.delete(`/branch/${id}/`);
  },
  companyWiseBranch: async (id) => {
    return await API.get(`/companies/${id}/branches/`);
  },
};

const financialApiEndpoints = {
  retrieveList: async (signal) => {
    return await API.get('admin/financial-years/', {
      signal,
    });
  },
  // retrieve: async (id, signal) => {
  //   return await API.get(`/branch/${id}/`, {
  //     signal,
  //   });
  // },
  create: async (data) => {
    return await API.post('admin/financial-years/', data);
  },
  update: async (id, data) => {
    return await API.patch(`admin/financial-years/${id}/`, data);
  },
  delete: async (id) => {
    return await API.delete(`admin/financial-years/${id}/`);
  },
  // companyWiseBranch: async (id) => {
  //   return await API.get(`/companies/${id}/branches/`);
  // },
};

const countryApiEndPoints = {
  retreiveList: async () => {
    return await API.get(`admin/countries/`);
  },
};

const customerApiEndpoints = {
  companyWiseCustomer: async (id) => {
    return await API.get(`admin/branches/${id}/users-roles/ `);
  },

  retrieveList: async (signal) => {
    return await API.get(`/users/`, {
      params: { isActive: true },
      signal,
    });
  },
  retrieveListFalse: async (signal) => {
    return await API.get(`/users/`, {
      params: { isActive: false },
      signal,
    });
  },
  superAdminRetrieveList: async (signal) => {
    return await API.get('admin/users/', {
      signal,
      params: {
        isActive: true,
      },
    });
  },
  superAdminActivateUserList: async (signal) => {
    return await API.get('admin/users/', {
      signal,
      params: {
        isActive: false,
      },
    });
  },
  retrieveCustomList: async (signal) => {
    return await API.get('/admin/list/', {
      signal,
    });
  },
  retrieveActivateList: async (signal) => {
    return await API.get('/active/users/', {
      signal,
    });
  },
  retrieve: async (id, signal) => {
    return await API.get(`/user/${id}/`, {
      signal,
    });
  },
  superAdminRetrieve: async (id, signal) => {
    return await API.get(`admin/users/${id}/`, {
      signal,
    });
  },
  create: async (data) => {
    return await API.post('/users/', data);
  },
  superAdminCreate: async (data) => {
    return await API.post('admin/users/', data);
  },
  update: async (id, data) => {
    return await API.patch(`/user/${id}/`, data);
  },
  superAdminUpdate: async (id, data) => {
    return await API.patch(`admin/users/${id}/`, data);
  },
  superAdminActive: async (id) => {
    return await API.patch(`toggle/admin/${id}/`);
  },
  // superAdminInactive: async (id) => {
  //   return await API.patch(`toggle/admin/${id}/`);
  // },
  delete: async (id) => {
    return await API.delete(`/user/${id}/`);
  },
  getLogging: async () => {
    return await API.get('/user/log/details/');
  },
  active: async (id) => {
    return await API.patch(`/toggle/user/${id}/`);
  },
  clearToken: async (username) => {
    return await API.post('/end-users/clear-token/', { username });
  },
  isAdmin: async (data) => {
    return await API.post('/user/admin/', data);
  },
  resetUserPassword: async (id, data) => {
    return await API.patch(`admin/user/${id}/password/reset/`, data);
  },
  resetAdminPassword: async (id, data) => {
    return await API.patch(`superadmin/admin/${id}/password/reset/`, data);
  },
};

const qzTrayApiEndpoints = {
  retrieveList: async (signal) => {
    return await API.get(`/transaction/qz-tray-setup/`, {
      // params: { isActive: true },
      signal,
    });
  },

  retrieve: async (id, signal) => {
    return await API.get(`/transaction/qz-tray-setup/${id}/`, {
      signal,
    });
  },

  create: async (data) => {
    return await API.post('/transaction/qz-tray-setup/', data);
  },

  update: async (id, data) => {
    return await API.patch(`/transaction/qz-tray-setup/${id}/`, data);
  },

  delete: async (id) => {
    return await API.delete(`/transaction/qz-tray-setup/${id}/`);
  },
};

const barcodeApiEndPoints = {
  create: async (data) => {
    return await API.post('/printers/', data);
  },
  list: async (id) => {
    return await API.get('/printers/');
  },
  update: async (id, data) => {
    return await API.patch(`/printer/${id}/`, data);
  },
  delete: async (id) => {
    return await API.delete(`/printer/${id}/`);
  },
  retrieveList: async (id) => {
    return await API.get(`/printer/${id}/`);
  },

  printLayouts: async () => {
    return await API.get(`/printer-layouts/`);
  },
  createPrintLayout: async (data) => {
    return await API.post('/printer-layouts/', data);
  },
  updatePrintLayout: async (id, data) => {
    return await API.patch(`/printer-layout/${id}/`, data);
  },
  deletePrintLayout: async (id) => {
    return await API.delete(`/printer-layout/${id}/`);
  },
};

const versionApiEndpoints = {
  list: async (signal) => {
    return await API.get('/superadmin/versions/', {
      signal,
    });
  },
  retrieve: async (id, signal) => {
    // /subscription/{id}/findById/
    return await API.get(`/superadmin/versions/${id}/`, {
      signal,
    });
  },
  create: async (data) => {
    return await API.post('/superadmin/versions/', data);
  },
  update: async (id, data) => {
    return await API.patch(`/superadmin/versions/${id}/`, data);
  },
  delete: async (id) => {
    return await API.delete(`/superadmin/versions/${id}/`);
  },
};

const subscribeApiEndpoints = {
  list: async (signal) => {
    return await API.get('/subscription/list/', {
      signal,
    });
  },
  retrieveList: async (signal) => {
    return await API.get('/subscription/access/list/', {
      signal,
    });
  },
  retrieve: async (id, signal) => {
    // /subscription/{id}/findById/
    return await API.get(`/subscription/${id}/findById/`, {
      signal,
    });
  },
  create: async (data) => {
    return await API.post('/subscription/create/', data);
  },
  update: async (id, data) => {
    return await API.patch(`/subscription/${id}/update/`, data);
  },
  delete: async (id) => {
    return await API.delete(`/subscription/${id}/delete/`);
  },
};

const roleApiEndpoints = {
  companyWiseRole: async (id) => {
    return await API.get(`company/wise/role/list/?companyId=${id}`);
  },
  retrieveList: async (signal) => {
    return await API.get('/roles/', {
      signal,
    });
  },

  retrieve: async (id, signal) => {
    // /subscription/{id}/findById/
    return await API.get(`/role/${id}/`, {
      signal,
    });
  },
  create: async (data) => {
    return await API.post('/roles/', data);
  },
  update: async (id, data) => {
    return await API.patch(`/role/${id}/`, data);
  },
  delete: async (id) => {
    return await API.delete(`/role/${id}/`);
  },

  mapping: async (data) => {
    return await API.post('/user/roles/mapping/', data);
  },
  mappingdelete: async (id) => {
    return await API.delete(`user/role/mapping/${id}/`);
  },
  menuMapping: async (data) => {
    return await API.post('/role/menus/permission/', data);
  },
  menuMappingList: async () => {
    return await API.get('/role/menus/permission/');
  },
  menuMappingRetrieve: async (roleId, branchId, companyId, signal) => {
    /**
     * retrieve menu role wise
     */
    return await API.get('/role/menu/permission/', {
      params: {
        roleId,
        branchId,
        companyId,
      },
      signal,
    });
  },
  menuMappingUpdate: async (data) => {
    return await API.post('/role/menu/permission/', data);
  },
  roleMenuMappingUpdate: async (data) => {
    return await API.patch('/role/menu/permission/', data);
  },
  roleMappingList: async () => {
    return await API.get('/user/roles/mapping/');
  },
  retrieveUserRoleMapping: async (id, signal) => {
    return await API.get(`/user/role/mapping/${id}/`, {
      signal,
    });
  },
  roleMappingUpdate: async (id, data) => {
    return await API.patch(`/user/role/mapping/${id}/`, data);
  },
};

const superAdminVersionApiEndpoints = {
  retrieveList: async (signal) => {
    return await API.get('/superadmin/version/menu/mapping/', {
      signal,
    });
  },

  retrieve: async (id, signal) => {
    // /subscription/{id}/findById/
    return await API.get(`/superadmin/version/menu/mapping/${id}/`, {
      signal,
    });
  },
  create: async (data) => {
    return await API.post('/superadmin/version/menu/mapping/', data);
  },
  update: async (id, data) => {
    return await API.patch(`/superadmin/version/menu/mapping/${id}/`, data);
  },
  delete: async (id) => {
    return await API.delete(`/superadmin/version/menu/mapping/${id}/`);
  },

  mapping: async (data) => {
    return await API.post('/user/roles/mapping/', data);
  },
  mappingdelete: async (id) => {
    return await API.delete(`user/role/mapping/${id}/`);
  },
  menuMapping: async (data) => {
    return await API.post('/role/menus/permission/', data);
  },
  menuMappingList: async () => {
    return await API.get('/role/menus/permission/');
  },
  menuMappingRetrieve: async (roleId, branchId, signal) => {
    /**
     * retrieve menu role wise
     */
    return await API.get('/role/menu/permission/', {
      params: {
        roleId,
        branchId,
      },
      signal,
    });
  },
  menuMappingUpdate: async (data) => {
    return await API.post('/role/menu/permission/', data);
  },
  roleMenuMappingUpdate: async (data) => {
    return await API.patch('/role/menu/permission/', data);
  },
  roleMappingList: async () => {
    return await API.get('/user/roles/mapping/');
  },
  retrieveUserRoleMapping: async (id, signal) => {
    return await API.get(`/user/role/mapping/${id}/`, {
      signal,
    });
  },
  roleMappingUpdate: async (id, data) => {
    return await API.patch(`/user/role/mapping/${id}/`, data);
  },
};

const menuApiEndpoints = {
  retrieveList: async (signal) => {
    return await API.get('/menus/', {
      signal,
    });
  },

  retrieveListWithVersion: async ({ signal, companyId, branchId }) => {
    return await API.get(
      `companies/${companyId}/branches/${branchId}/menus/version-wise/`,
      {
        signal,
      },
    );
  },

  retrieve: async (id, signal) => {
    // /subscription/{id}/findById/
    return await API.get(`/menu/${id}/findById/`, {
      signal,
    });
  },
  create: async (data) => {
    return await API.post('/menu/create/', data);
  },
  update: async (id, data) => {
    return await API.patch(`/menu/${id}/update/`, data);
  },
  delete: async (id) => {
    return await API.delete(`/menu/${id}/delete/`);
  },

  parentMapping: async (data) => {
    return await API.post('/menu/parent/child/create/', data);
  },
  parentMappingUpdate: async (data) => {
    return await API.post('/menu/parent/child/update/', data);
  },
  menuMappingRetrieve: async (id, signal) => {
    return await API.get(`/menu/parent/child/${id}/findById/`, { signal });
  },
  menuParentList: async () => {
    return await API.get('/menu/parent/child/list/');
  },
};

const userCompanyMappingApiEndpoints = {
  create: async (data) => {
    return await API.post('/user/company/mapping/create/', data);
  },
  retrieveList: async () => {
    return await API.get('/user/company/mapping/list/');
  },
  retrieve: async (roleId, signal) => {
    return await API.get(`/user/company/mapping/${roleId}/findById/`, {
      signal,
    });
  },
  update: async (id, data) => {
    return await API.patch(`/user/company/mapping/${id}/update/`, data);
  },

  delete: async (id) => {
    return await API.delete(`/user/company/mapping/${id}/delete`);
  },
};

const companyMenuMappingApiEndpoints = {
  create: async (data) => {
    return await API.post('/company/menu/mapping/create/', data);
  },
  retrieveList: async () => {
    return await API.get('/company/menu/mapping/list/');
  },
  retrieve: async (roleId, signal) => {
    return await API.get(`/company/menu/mapping/${roleId}/findById/`, {
      signal,
    });
  },
  update: async (id, data) => {
    return await API.patch(`/company/menu/mapping/${id}/update/`, data);
  },

  delete: async (id) => {
    return await API.delete(`/company/menu/mapping/${id}/delete`);
  },
};

const deviceIdsApiEndpoints = {
  retrieveList: async () => {
    return await API.get('/admin/devices/');
  },
  delete: async (id) => {
    return await API.delete(`/admin/devices/${id}/`);
  },
};

export {
  adminMenuApiEndpoints,
  companyApiEndpoints,
  companyAccessEndpoints,
  branchAccessEndpoints,
  branchApiEndpoints,
  customerApiEndpoints,
  subscribeApiEndpoints,
  roleApiEndpoints,
  menuApiEndpoints,
  userCompanyMappingApiEndpoints,
  qzTrayApiEndpoints,
  companyMenuMappingApiEndpoints,
  barcodeApiEndPoints,
  versionApiEndpoints,
  superAdminVersionApiEndpoints,
  financialApiEndpoints,
  deviceIdsApiEndpoints,
  countryApiEndPoints,
};
